var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubsIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 14.3262V12.9928C14.6668 11.7503 13.817 10.7062 12.6668 10.4102M10.3335 2.52001C11.3108 2.9156 12.0002 3.87371 12.0002 4.99284C12.0002 6.11196 11.3108 7.07007 10.3335 7.46567M11.3335 14.3262C11.3335 13.0837 11.3335 12.4624 11.1305 11.9723C10.8599 11.3189 10.3407 10.7998 9.68732 10.5292C9.19726 10.3262 8.57601 10.3262 7.3335 10.3262H5.3335C4.09099 10.3262 3.46973 10.3262 2.97967 10.5292C2.32627 10.7998 1.80713 11.3189 1.53648 11.9723C1.3335 12.4624 1.3335 13.0837 1.3335 14.3262M9.00016 4.99284C9.00016 6.4656 7.80625 7.65951 6.3335 7.65951C4.86074 7.65951 3.66683 6.4656 3.66683 4.99284C3.66683 3.52008 4.86074 2.32617 6.3335 2.32617C7.80625 2.32617 9.00016 3.52008 9.00016 4.99284Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubsIco);
export default __webpack_public_path__ + "static/media/hubs-ico.30df212cd71ccf8ccf6b2a14cbe59732.svg";
export { ForwardRef as ReactComponent };